export const defaultStyle = height => `
    height: ${height}%;
`;

export const stickyStyle = `
    position: sticky;
    top: 100px;
`;
